import { GTMContextType, GTMContext } from '@src/config/gtm';
import { useContext } from 'react';

export const useGTM = (): GTMContextType => {
  const context = useContext(GTMContext);
  if (!context) {
    throw new Error('useGTM must be used within a GTMProvider');
  }
  return context;
};
